import { UICrumb } from './UICrumb';

export interface UIData {
    popupID?: string;
    params?: any;
}

export interface UIDataPrio {
    popupIDPrio?: string;
    paramsPrio?: any;
}

export interface IUIState {
    popupID?: string;
    params?: any;
    queue?: UIData[];
    crumb?: UICrumb;
}

export interface IUIStatePrio {
    popupIDPrio?: string;
    paramsPrio?: any;
    queuePrio?: UIDataPrio[];
}

export const initialUIState: IUIState = {
    popupID: null,
    params: null,
    queue: [],
};
export const initialUIStatePrio: IUIStatePrio = {
    popupIDPrio: null,
    paramsPrio: null,
};
